module.exports = __webpack_public_path__ + "img/delete.72c491d0.svg";